import type { OtherVideo, VideoLastPublish } from '../types.ts/story';

/**
 * Collects all publish info from a video and its associated videos.
 * Returns an array of non-null VideoLastPublish objects.
 */
export function getAllPublishInfo(video: OtherVideo): VideoLastPublish[] {
  return [
    video.lastPublishJson,
    ...(video.associatedVideos?.map(v => v.lastPublishJson) || []),
  ].filter(Boolean) as VideoLastPublish[];
}

/**
 * Finds the most recent publish info from an array of publish info objects.
 * Returns undefined if the array is empty.
 */
export function getMostRecentPublishInfo(
  lastPublishInfo: VideoLastPublish[],
): VideoLastPublish | undefined {
  return lastPublishInfo.reduce<VideoLastPublish | undefined>(
    (latest, current) =>
      !latest || new Date(current.timestamp) > new Date(latest.timestamp)
        ? current
        : latest,
    undefined,
  );
}
